<template>
  <ui-content title="Reporte por movilidad">
    <ui-card v-if="loading.view == false">
      <ValidationObserver ref="form">
        <div class="row form-row mb-2">
          <div class="col-lg-3">
            <label for="" class="form-label">Vehículo:</label>
            <InputSelect
              v-model="form.vehiculo"
              :options="containers.vehiculos"
              :rules="'required'"
              :name="'Vehículo'"
              :vid="'vehiculo'"
              :getOptionLabel="
                opt =>
                  opt.placa
                    ? `${opt.identificador} (${opt.placa})`
                    : opt.identificador
              "
            ></InputSelect>
          </div>
          <div class="col-lg-3">
            <label for="" class="form-label">Fecha Inicio:</label>
            <InputDatepicker
              v-model="form.fechaInicio"
              rules="required"
              name="Fecha Inicio"
              input-class="form-control form-control-sm"
            ></InputDatepicker>
          </div>
          <div class="col-lg-3">
            <label for="" class="form-label">Fecha Fin:</label>
            <InputDatepicker
              v-model="form.fechaFin"
              rules="required"
              name="Fecha Fin"
              input-class="form-control form-control-sm"
            ></InputDatepicker>
          </div>
        </div>
      </ValidationObserver>
      <div class="form-group">
        <button
          class="btn btn-primary"
          @click="onSearch"
          :disabled="loading.search"
        >
          Buscar
        </button>
        <template v-if="containers.records.length">
          <button class="btn btn-outline-secondary ml-2" @click="print">
            Imprimir
          </button>
        </template>
      </div>
      <hr />
      <template v-if="containers.records.length">
        <VehiculosTable :rows="containers.records" />
      </template>
    </ui-card>
  </ui-content>
</template>
<script>
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import VehiculosTable from "../components/VehiculosTable.vue";
import DatePicker from "vue2-datepicker";
import reportePorMovilidadPdf from "../pdf/reportePorMovilidad.pdf";

export default {
  components: {
    DatePicker,
    InputSelect,
    InputDatepicker,
    VehiculosTable
  },
  data() {
    return {
      form: {
        vehiculo: null,
        fechaInicio: "2022-08-01",
        fechaFin: "2022-09-30"
      },
      reportes: [],
      containers: {
        vehiculos: [],
        records: []
      },
      loading: {
        view: true,
        search: false
      }
    };
  },
  async created() {
    const vm = this;

    try {
      let response = await vm.axios.get("/vehiculos");
      vm.containers.vehiculos = response.data;

      vm.loading.view = false;
    } catch (error) {
      console.log({ error });
    }
  },
  methods: {
    async onSearch() {
      const vm = this;

      const validated = await vm.$refs.form.validate();

      if (!validated) {
        vm.$toast.fire({
          title: "Completa los campos requeridos",
          icon: "warning"
        });
        return;
      }

      if (vm.$dayjs(vm.form.fechaInicio) > vm.$dayjs(vm.form.fechaFin)) {
        return vm.$toast.fire(
          "Fecha inicio no puede ser mayor a fecha fin",
          "",
          "warning"
        );
      }

      vm.containers.records = [];
      vm.loading.search = true;

      try {
        const response = await vm.axios.get(`/reportes/vehiculos`, {
          params: {
            idVehiculo: vm.form.vehiculo.idVehiculo,
            fechaInicio: vm.form.fechaInicio,
            fechaFin: vm.form.fechaFin
          }
        });

        const records = response.data.map((item, idx) => ({
          ...item,
          idx
        }));

        this.containers.records = records;
      } catch (error) {
        console.error(error);
      } finally {
        vm.loading.search = false;
      }
    },
    print() {
      const vm = this;

      const { vehiculo, fechaInicio, fechaFin } = this.form;

      reportePorMovilidadPdf({
        header: {
          vehiculo: vehiculo.placa
            ? `${vehiculo.identificador} (${vehiculo.placa})`
            : vehiculo.identificador,
          fechaInicio: vm.$options.filters.date(fechaInicio),
          fechaFin: vm.$options.filters.date(fechaFin)
        },
        records: this.containers.records,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm")
      });
    }
  }
};
</script>
